import { render } from "./SquaresButton.vue?vue&type=template&id=2e452463"
import script from "./SquaresButton.vue?vue&type=script&lang=js"
export * from "./SquaresButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__